export default "__VITE_ASSET__CVSlxqfk__"